<template>
	<div class="edit-bar">
		<b-btn class="new-btn mr-4"
		       variant="warning"
		       v-b-modal.newobject>
			Neu
		</b-btn>

		<erco-dropdown v-if="activeObjectsSelected"
		               class="mr-1"
		               label="Aktion"
		               :items="actions"
		               :useLabelInline="true"
		               @change="handleActionClick">
		</erco-dropdown>

		<erco-dropdown v-if="activeObjectsSelected"
		               class="mr-1"
		               label="Status ändern"
		               :items="statiList"
		               :useLabelInline="true"
		               @change="handleStatiClick">
		</erco-dropdown>

		<b-btn v-if="activeObjectsSelected"
		       class="selection-reset ml-4"
		       variant="primary"
		       @click="handleObjectSelectionReset">
			Auswahl aufheben
		</b-btn>

		<b-modal id="newobject"
		         class="new-object-modal"
		         title="Neues Objekt anlegen"
		         closeTitle="Schließen"
		         @ok="handleNewClick"
		         @shown="clearNewObjectDataset">
			<b-alert class="alert-list"
			         variant="warning"
			         :show="alertTextList.length > 0">
				<p v-for="(alertText, index) in alertTextList"
                   class="_item"
				   :key="index">
					&bull; {{alertText}}
				</p>
			</b-alert>

			<erco-text-input label="Objektname"
							 ref="modalObjectnameInput"
			                 @change="handleObjectnameChange">
			</erco-text-input>

			<erco-dropdown class="mr-1 d-block specification-dropdown"
		                   label="Spezifikation"
		                   ref="modalObjectSpecificationDropdown"
		                   :items="userSpecificationsDropdown"
		                   @change="handleSpecificationClick">
			</erco-dropdown>

			<erco-dropdown class="mr-1 d-block genus-dropdown"
		                   label="Gattung"
		                   ref="modalObjectGenusDropdown"
		                   :items="selectedUserSpecificationGenusDropdown"
		                   @change="handleGenusClick">
			</erco-dropdown>
		</b-modal>

		<b-modal id="action-confirmation"
		         ref="actionConfirmation"
		         class="action-confirmation-modal"
		         title="Statusänderung"
		         closeTitle="Abbrechen"
		         @ok="handleStatiModalClick"
		         @shown="resetSelectedActionStatus">

			<p class="_infotext">
				<span v-if="activeObjectSelection.length === 1">Den Status des folgenden Objekts</span>
				<span v-else>Den Status der folgenden Objekte</span>
				wirklich auf <span class="font-weight-bold">{{ selectedActionStatus.currentText }}</span> setzen?
			</p>

			<div class="selected-obj-list-container">
				<b-list-group class="selected-obj-list"
				              v-if="activeObjectSelection.length > 0">
						<b-list-group-item v-for="selectedObj in activeObjectSelection"
						                   :key="selectedObj.PKM_Objekt"
						                   class="_entry_">
							<span class="_image"
							      :style="`background-image: url(${getImageSrcForObject(selectedObj)});`"
							></span>
							<span class="_title font-weight-bold">{{ selectedObj.S_de_Objekt }}</span>
							<span class="_id float-left text-muted">{{ selectedObj.PKM_Objekt }}</span>
							<span class="_badge">
								<erco-status-badge :status="selectedObj.S_Status">
								</erco-status-badge>
							</span>
						</b-list-group-item>
				</b-list-group>
			</div>

		</b-modal>

	</div>
</template>
<script>
	import DashboardService from '@/api/dashboard';
	import ErcoStatusBadge from '@/components/atoms/ErcoStatusBadge';
	import ErcoTextInput from '@/components/molecules/ErcoTextInput';
	import ErcoDropdown from '@/components/molecules/ErcoDropdown';

	export default {
		name: 'ErcoEditbarOrganism',
		data() {
			return {
				actions: [
					{
						value: 'clone',
						text: 'klonen',
					},
					{
						value: 'emptyCopy',
						text: 'leer kopieren',
					},
				],
				newObjectData: {
					specificationId: '',
					genusId: '',
					objectname: '',
				},
				alertTextList: [],
				selectedActionStatus: {},
			};
		},
		props: {
		},
		computed: {
			statiList() {
				return this.$store.getters.dashboardStati.map(status =>
					({
						value: status.PKM_Status,
						text: status.S_Status_Uppercase,
					}),
				);
			},

			userSpecifications() {
				const userSpecifications =
					JSON.parse(JSON.stringify(this.$store.state.dashboard.userSpecifications));

				const sortedUserSpecifications =
					userSpecifications
					.sort((a, b) => {
						const lcASpec = a.S_Spezifikation.toLowerCase();
						const lcBSpec = b.S_Spezifikation.toLowerCase();
						return lcASpec.localeCompare(lcBSpec);
					});

				return sortedUserSpecifications;
			},

			userSpecificationsDropdown() {
				const userSpecifications =
					this.userSpecifications.map(specification =>
						({
							text: specification.S_Spezifikation,
							value: specification.PKM_Spezifikation,
						}),
					);

				userSpecifications.unshift({
					text: 'Bitte auswählen...',
					value: '',
				});

				return userSpecifications;
			},

			selectedUserSpecificationGenus() {
				/* Dekremenrierung des Index, um den 'Bitte auswählen'-Eintrag zu berücksichtigen */
				const foundSpecification = this.userSpecifications.find(
					spec => spec.PKM_Spezifikation === this.newObjectData.specificationId);

				const gattungen = (foundSpecification) ?
					JSON.parse(JSON.stringify(foundSpecification.gattungen)) :
					[];

				const sortedGattungen =
					gattungen
					.sort((a, b) => {
						const lcAGattung = a.S_Gattung.toLowerCase();
						const lcBGattung = b.S_Gattung.toLowerCase();
						return lcAGattung.localeCompare(lcBGattung);
					});

				return sortedGattungen;
			},

			selectedUserSpecificationGenusDropdown() {
				const selectedUserSpecificationGenus =
					this.selectedUserSpecificationGenus.map(genus =>
						({
							text: genus.S_Gattung,
							value: genus.PKM_Gattung,
						}),
					);

				selectedUserSpecificationGenus.unshift({
					text: 'Bitte auswählen...',
					value: '',
				});

				return selectedUserSpecificationGenus;
			},

			activeObjectSelection() {
				return this.$store.getters.selectedDashboardObjects;
			},

			activeObjectsSelected() {
				return this.activeObjectSelection.length > 0;
			},
		},
		methods: {
			handleNewClick(e) {
				let valid = true;
				this.alertTextList = [];

				if (this.newObjectData.objectname.length === 0) {
					valid = false;
					this.alertTextList.push('Keinen Objektnamen eingegeben');
				}
				if (this.newObjectData.specificationId.trim().length === 0) {
					valid = false;
					this.alertTextList.push('Keine Spezifikation ausgewählt');
				}
				if (this.newObjectData.genusId.length === 0) {
					valid = false;
					this.alertTextList.push('Keine Gattung ausgewählt');
				}

				if (!valid) {
					e.cancel();
					return;
				}

				DashboardService.createNewObject(
					this.newObjectData.specificationId.trim(),
					this.newObjectData.genusId,
					this.newObjectData.objectname,
				)
				.then((response) => {
					const objectId = response.PKM_Objekt;
					/* lastFecthAt invalidieren, um auch das neu erstellte Objekt beziehen zu können */
					this.$store.dispatch('invalidateLastFetchAt');
					this.$router.push({ path: `/objectview/${objectId}` });
				})
				.catch(() => {
					e.cancel();
				});
			},
			handleActionClick(value) {
				this.$store.dispatch('triggerActionOnDashboardObjects', value.currentValue);
			},
			handleStatiClick(value) {
				this.$refs.actionConfirmation.show();
				this.selectedActionStatus = value;
			},
			handleStatiModalClick() {
				this.$store.dispatch('changeStatusOnDashboardObjects', this.selectedActionStatus.currentValue);
			},
			resetSelectedActionStatus() {
				this.selectedActionStatus = {};
			},
			handleObjectnameChange(value) {
				this.newObjectData.objectname = value;
			},
			clearNewObjectDataset() {
				this.newObjectData.specificationId = '';
				this.$refs.modalObjectSpecificationDropdown.resetSelection();

				this.newObjectData.genusId = '';
				this.$refs.modalObjectGenusDropdown.resetSelection();

				this.newObjectData.objectname = '';
				this.$refs.modalObjectnameInput.resetInput();
			},
			handleSpecificationClick(data) {
				this.newObjectData.specificationId = data.currentValue;
			},
			handleGenusClick(data) {
				this.newObjectData.genusId = data.currentValue;
			},
			handleObjectSelectionReset() {
				this.$store.dispatch('handleObjectSelection', { type: 'empty' });
			},
			getImageSrcForObject(obj) {
				if (obj.S_Stellvertreterbild) {
					return `${process.env.IMG_SERVER}/system/images/web/${obj.S_Stellvertreterbild}`;
				}
				return process.env.PLACEHOLDER_IMAGE_URL;
			},
		},
		components: {
			ErcoStatusBadge,
			ErcoTextInput,
			ErcoDropdown,
		},
	};
</script>

<style lang="scss">

	.edit-bar {
		& > .new-btn {
			cursor: pointer;
		}

		& > .new-object-modal {
			.modal {
				display: block;
			}

			.alert-list {
				._item:last-child {
					margin-bottom: 0;
				}
			}
		}

		& > .action-confirmation-modal {
			.modal {
				display: block;
			}

			._infotext {
				margin: 0.5rem 0 2rem;
			}

			.selected-obj-list-container {
				max-height: 300px;
				overflow: auto;

				> .selected-obj-list {
					> ._entry_ {
						display: flex;

						._image {
							display: inline-block;
							background-size: cover;
							background-position: center;
							height: 50px;
							width: 60px;
						}

						._title {
							flex: 1;
							padding-left: 1rem;
						}

						._id {
							flex: 0;
							padding-right: 0.5rem;
						}

						._badge {
							width: 4rem;
							text-align: right;
						}

					}
				}
			}
		}

		.specification-dropdown,
		.genus-dropdown {
			.dropdown-toggle,
			.dropdown-menu {
				min-width: 100%;
			}

			.dropdown-toggle {
				text-align: left;

				&:after {
					position: absolute;
					right: 1rem;
					top: 40%;
				}
			}

			.dropdown-menu {
				max-height: 9.5rem;
				overflow-y: auto;
			}
		}

		.genus-dropdown {
			margin-top: 1.5rem;
		}
	}

</style>



// WEBPACK FOOTER //
// ErcoEditbar.vue?9e465990